import Vue from 'vue';
import Router from 'vue-router';

import Session from "@/views/Session";

Vue.use(Router);


const router = new Router({
    routes: [
        {
            path: '/',
            name: 'session',
            component: Session,
        },
    ]
});

export default router;